import { AppDomainConfig } from "../../envConfig";
import { CustomerType, RoutingService } from "../../utils/constants";
import colors from "../ch/colors";
import iconCategories from "../ch/icons.json";

const config: Partial<AppDomainConfig> = {
  customerType: CustomerType.OTHER,
  domains: ["ch", "io", "app"],
  font: "16px arial",
  iconCategories,
  id: "geops",
  name: "geOps",
  pictures: [
    { id: "single_train2_v1.png" },
    { id: "single_train_v1.png" },
    { id: "single_train_long_nose_v1.png" },
    { id: "train_long_nose_double_v1.png" },
    { id: "double_train_v1.png" },
    { id: "single_bus_v1.png" },
    { id: "double_bus_v1.png" },
    { id: "tram_v1.png" },
    { id: "tram_long_v1.png" },
    { id: "rbs_train_v1.png" },
    { id: "rbs_bus_v1.png" },
    { id: "rbs_bus2_v1.png" },
    { id: "rbs_double_bus_v1.png" },
    { id: "rbs_single_train_v1.png" },
    { id: "vbz_bus_v1.png" },
    { id: "vbz_double_bus_v1.png" },
    { id: "vbz_tram_v1.png" },
    { id: "vbz_tram_long_v1.png" },
    { id: "postbus_v1.png" },
    { id: "postbus_double_v1.png" },
    { id: "taxi_v1.png" },
  ],
  previewBaselayers: true,
  routingBarrierFree: false,
  routingMots: ["car", "bike", "foot"], // Only mots allowed for graphopper free tier
  // [Test configuration] Simulates an events-manager customer (Places search
  // without stops search).
  routingService: RoutingService.Graphhopper,
  settings: {
    stops_api_bbox: "5.657959,45.675482,10.722656,47.908978",
    stops_api_prefagencies: "sbb",
  },
  slug: "geopstest",
  ...colors,
};

export default config;
